import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0D0D0D] text-white">
      <div className="h-[3px] bg-[#E6A800]" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-5">
              <div className="w-8 h-8 flex items-center justify-center bg-[#E6A800]">
                <span className="font-head text-white text-xs font-black">V</span>
              </div>
              <div>
                <div className="font-head text-white font-black text-sm tracking-[0.15em] uppercase">
                  VİP REKLAM
                </div>
                <div className="text-[#E6A800] text-[8px] tracking-[0.3em] uppercase font-head font-600">
                  Dekorasyon
                </div>
              </div>
            </div>
            <p className="text-[#616161] text-sm leading-relaxed mb-6">
              2004'ten bu yana Osmaniye'de reklam tabelası, cephe kaplama ve
              dekorasyon alanında güvenilir çözümler. 1.620+ tamamlanan proje.
            </p>
            <div className="flex gap-2">
              <a
                href="https://instagram.com/vip.tasarim"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Instagram"
                className="w-8 h-8 flex items-center justify-center border border-white/10 text-[#616161] hover:border-[#E6A800] hover:text-[#E6A800] tr cursor-pointer"
              >
                <i className="ri-instagram-line text-sm" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Facebook"
                className="w-8 h-8 flex items-center justify-center border border-white/10 text-[#616161] hover:border-[#E6A800] hover:text-[#E6A800] tr cursor-pointer"
              >
                <i className="ri-facebook-line text-sm" />
              </a>
              <a
                href="https://wa.me/905511830918"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="WhatsApp"
                className="w-8 h-8 flex items-center justify-center border border-white/10 text-[#616161] hover:border-[#E6A800] hover:text-[#E6A800] tr cursor-pointer"
              >
                <i className="ri-whatsapp-line text-sm" />
              </a>
            </div>
          </div>

          {/* Pages */}
          <div>
            <h4 className="font-head font-700 uppercase text-white text-xs tracking-[0.2em] mb-5">
              Sayfalar
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Ana Sayfa", href: "/" },
                { label: "Hizmetler", href: "/hizmetler" },
                { label: "Dekorasyon", href: "/dekorasyon" },
                { label: "Projeler", href: "/projeler" },
                { label: "Blog", href: "/blog" },
                { label: "Hakkımızda", href: "/hakkimizda" },
                { label: "Referanslar", href: "/referanslar" },
                { label: "İletişim", href: "/iletisim" },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-[#616161] text-sm hover:text-[#E6A800] tr cursor-pointer flex items-center gap-2 group font-head"
                  >
                    <span className="w-1 h-1 bg-[#E6A800]/40 group-hover:bg-[#E6A800] tr" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-head font-700 uppercase text-white text-xs tracking-[0.2em] mb-5">
              Hizmetler
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Reklam Tabela", slug: "reklam-tabela" },
                { label: "Cephe Kaplama", slug: "cephe-kaplama" },
                { label: "Kutu Harf Tabela", slug: "kutu-harf-tabela" },
                { label: "Totem Tabela", slug: "totem-tabela" },
                { label: "Işıklı Menü Board", slug: "isikli-menu-board" },
                { label: "Cafe & Restorant Dekorasyon", slug: "cafe-restorant-dekorasyon" },
                { label: "Grafik Tasarım", slug: "grafik-tasarim" },
                { label: "Anahtar Teslim Proje", slug: "anahtar-teslim-proje" },
                { label: "LED Teknolojisi", slug: "led-teknolojisi" },
                { label: "Matbaa & Baskı", slug: "matbaa-baski" },
              ].map((s) => (
                <li key={s.label}>
                  <Link
                    to={`/hizmetler/${s.slug}`}
                    className="text-[#616161] text-sm hover:text-[#E6A800] tr cursor-pointer flex items-center gap-2 group font-head"
                  >
                    <span className="w-1 h-1 bg-[#E6A800]/40 group-hover:bg-[#E6A800] tr" />
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-head font-700 uppercase text-white text-xs tracking-[0.2em] mb-5">
              İletişim
            </h4>
            <ul className="space-y-4 mb-6">
              <li className="flex items-start gap-2.5">
                <i className="ri-map-pin-line text-[#E6A800] text-sm mt-0.5 shrink-0" />
                <span className="text-[#616161] text-xs leading-snug">
                  Mehmet, Adnan Menderes, Mehmet Zahid Kotku Cd no: 36/1, 80010
                  Osmaniye Merkez/Osmaniye
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-line text-[#E6A800] text-sm mt-0.5 shrink-0" />
                <a
                  href="tel:+905511830918"
                  className="text-[#616161] text-xs hover:text-[#E6A800] tr cursor-pointer leading-snug"
                >
                  +90 551 183 09 18
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-phone-line text-[#E6A800] text-sm mt-0.5 shrink-0" />
                <a
                  href="tel:+905383024939"
                  className="text-[#616161] text-xs hover:text-[#E6A800] tr cursor-pointer leading-snug"
                >
                  +90 538 302 49 39
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-mail-line text-[#E6A800] text-sm mt-0.5 shrink-0" />
                <a
                  href="mailto:info@vipreklamdekorasyon.com"
                  className="text-[#616161] text-xs hover:text-[#E6A800] tr cursor-pointer leading-snug"
                >
                  info@vipreklamdekorasyon.com
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <i className="ri-time-line text-[#E6A800] text-sm mt-0.5 shrink-0" />
                <span className="text-[#616161] text-xs leading-snug">
                  Pazartesi – Cumartesi: 08:00 – 18:00
                </span>
              </li>
            </ul>
            <a
              href="https://wa.me/905511830918"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2.5 bg-[#25D366]/15 border border-[#25D366]/30 text-[#25D366] font-head font-600 uppercase tracking-wider text-xs hover:bg-[#25D366]/25 tr cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line" />
              WhatsApp İletişim
            </a>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#424242] text-xs font-head">
            © {currentYear} VİP Reklam Dekorasyon. Tüm hakları saklıdır.
          </p>
          <p className="text-[#424242] text-xs font-head">
            Osmaniye · Türkiye ·{" "}
            <a
              href="https://vipreklamdekorasyon.com"
              className="hover:text-[#E6A800] tr"
              rel="noopener noreferrer"
              target="_blank"
            >
              vipreklamdekorasyon.com
            </a>
          </p>
        </div>

        <a
          href="https://epiked.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 pt-5 border-t border-white/5 flex items-center justify-center gap-3 hover:opacity-90 tr"
        >
          <img
            src="/images/elogo.avif"
            alt="Epiked"
            className="h-6 w-auto object-contain"
          />
          <span className="text-[#BDBDBD] text-sm font-head">
            Profesyonel web sistemleri ile hazırlanmıştır.
          </span>
        </a>
      </div>
    </footer>
  );
};

export default Footer;